import React from "react";
import "./eventmedia-admin.css"; // styles for card/grid/buttons
const API = "https://api.ainfotech.com.np";

export default function EventMediaCard({ item, onEdit, onDelete }) {
  const img = item.cover_image ? `${API}${item.cover_image}` : null;

  return (
    <article className="em-card">
      <div className="em-card__thumb">
        {img ? <img src={img} alt={item.title} loading="lazy" /> : <div className="em-card__thumb--empty">No Image</div>}
      </div>

      <div className="em-card__body">
        <div className="em-card__tags">
          <span className="chip">{item.type}</span>
          {item.status && <span className="chip chip--muted">{item.status}</span>}
        </div>

        <h3 className="em-card__title">{item.title}</h3>
        <p className="em-card__excerpt">{item.excerpt}</p>

        {item.published_at && (
          <div className="em-card__date">
            {new Date(item.published_at).toLocaleDateString()}
          </div>
        )}

        <div className="em-card__actions">
          <button className="btn btn--ghost" onClick={() => onEdit(item)}>
            Edit
          </button>
          <button className="btn btn--danger" onClick={() => onDelete(item.id)}>
            Delete
          </button>
        </div>
      </div>
    </article>
  );
}
